/**
 * Created by Allan on 2024/07/17.
 * Contact 84880528@qq.com.
 * 下架APP的下载页面
 */
import Vue from 'vue'
import App from './App'
import router from '@/download/router/'
import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant);


new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/download/main.js